/**
 * @generated SignedSource<<2017533a94faaa3c86deb6bf60e73cf5>>
 * @relayHash c383562df6596a19a82df44992ef8ffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bcb3ca553fad0779e2802de26960a7c8a85fa7e426acb9860c8bd5d5fca4994f

import type { ConcreteRequest } from 'relay-runtime';
export type GrowthUnifiedProfileDomainType = "BUSINESS" | "PERSONAL" | "%future added value";
export type storageHardLimitModalQuery$variables = {
  shouldCheckContactSalesEligibility: boolean;
  userId: string;
};
export type storageHardLimitModalQuery$data = {
  readonly growthUnifiedProfile_getAccountProfile?: {
    readonly companyProfile: {
      readonly accountSegment: string | null;
      readonly domainType: GrowthUnifiedProfileDomainType;
    } | null;
  } | null;
};
export type storageHardLimitModalQuery = {
  response: storageHardLimitModalQuery$data;
  variables: storageHardLimitModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckContactSalesEligibility"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "condition": "shouldCheckContactSalesEligibility",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
          }
        ],
        "concreteType": "GrowthUnifiedProfileAccountProfileResult",
        "kind": "LinkedField",
        "name": "growthUnifiedProfile_getAccountProfile",
        "plural": false,
        "selections": [
          {
            "concreteType": "GrowthUnifiedProfileAccountCompanyRecord",
            "kind": "LinkedField",
            "name": "companyProfile",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountSegment"
              },
              {
                "kind": "ScalarField",
                "name": "domainType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "storageHardLimitModalQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "storageHardLimitModalQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "bcb3ca553fad0779e2802de26960a7c8a85fa7e426acb9860c8bd5d5fca4994f",
    "metadata": {},
    "name": "storageHardLimitModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8cb34fd69c20cc328efa3bf57bc9a17d";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
